import { Button, Modal, notification } from 'antd'
import React, { useState } from 'react'

import { httpClient } from '../../../../../util/http-client'
import { issuerCompliancesRulesMessages } from '../messages'
import { IssuerComplianceRule } from '../models'

interface DeleteIssuerComplianceRuleProps {
  domain: string
  complianceGroupId: number
  issuerComplianceRule: IssuerComplianceRule
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteIssuerComplianceRuleModal = ({
  domain,
  complianceGroupId,
  issuerComplianceRule,
  isVisible,
  onClose,
  onSuccess,
}: DeleteIssuerComplianceRuleProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (complianceGroupId: number, complianceRuleId: number) => {
    setIsDeleting(true)

    try {
      await httpClient(`/compliances/issuers/groups/${complianceGroupId}/rules/${issuerComplianceRule?.id}`, {
        method: 'DELETE',
        domain,
      })
      onSuccess()

      notification.success({
        message: issuerCompliancesRulesMessages.common.success,
        description: issuerCompliancesRulesMessages.delete.success,
      })
    } catch (error) {
      notification.error({
        message: issuerCompliancesRulesMessages.common.error,
        description: error.error_message || issuerCompliancesRulesMessages.delete.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete Counterparty Compliance Rule"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(complianceGroupId, issuerComplianceRule.id)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
          >
            Delete
          </Button>
        </div>,
      ]}
    >
      {buildDeleteMessage(issuerComplianceRule)}
    </Modal>
  )
}

const buildDeleteMessage = (issuerComplianceRule: IssuerComplianceRule) =>
  `Are you sure that you want to delete this counterparty compliance rule?\n
  - Rating type: ${issuerComplianceRule?.ratingType}\n
  - Rating: ${issuerComplianceRule?.rating}\n
  - Max Limit: ${issuerComplianceRule?.maxLimit}\n
  It cannot be reverted`
